import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import { withRouter } from 'react-router';
import { deslugifyParam } from 'utils/url';

import CreateReview from '../components/reviews/CreateReview';
import { isUserLoggedIn } from 'apps/user/helpers';
import {
  updateFields,
  validateNickname,
} from 'apps/products/actions/reviews';

const getSkuFromParams = (params) => deslugifyParam(params.sku);

export default withRouter(provideHooks({})(connect((state, ownProps) => {
  const sku = ownProps.sku || getSkuFromParams(ownProps.params);
  return {
    ...ownProps,
    sku,
    userId: state.user.customerNum,
    isLoggedIn: isUserLoggedIn(state.user),
    step: state.reviews.addReview.step,
  };
}, {
  updateFields,
  validateNickname,
})(CreateReview)));
